import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { toast } from 'react-toastify';
import Lottie from 'react-lottie-player';

import RequestForm from './components/RequestForm';
import animationData from 'Shared/spiner_blue.json';
import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import { logger } from 'RootShared/utility/ErrorLogger';
import useDocumentTitle from 'Shared/hooks/useDocumentTitle';

export const queryGetReasons = gql`
  query TabRequestQuery @api(name: root) {
    expenseReasons {
      id
      text
    }
  }
`;

const TabRequest = () => {
  const { loading, data, error } = useQuery(queryGetReasons);

  useDocumentTitle('Expenses - Request');

  if (error) {
    logger.error(error);
    toast(error.message, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeButton: true,
      hideProgressBar: false,
    });
  }

  return (
    <>
      {loading && (
        <Lottie
          data-testid="tab_request_loading"
          className="lottie"
          loop={true}
          play={true}
          animationData={animationData}
          width={100}
          style={{ width: 100, height: 100, margin: '0px auto' }}
        />
      )}
      {data && (
        <div className="tab-request" data-testid="tab_request">
          <div className="container container_sm">
            <RequestForm
              reasonData={data.expenseReasons.map((item) => ({
                id: item.id,
                label: item.text,
                value: item.text,
              }))}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default withErrorBoundary(TabRequest);
